import { useEffect } from 'react';
import { updateHeader } from 'common/services/common.service';
import ActionItemsOverTimeContainer from 'pages/dashboard/components/ActionItemsOverTimeContainer/ActionItemsOverTimeContainer';
import BurnRatioOverTimeContainer from 'pages/dashboard/components/BurnRatioOverTimeContainer/BurnRatioOverTimeContainer';

import './MsspDashboard.scss';

export function MsspDashboard() {
  useEffect(() => {
    updateHeader.sendHeaderText('Dasboard');
  }, []);

  return (
    <div className="MsspDashboard">
      <div className="mssp-dashboard-wrapper">
        <div className="action-item-over-time-chart">
          <div>
            <ActionItemsOverTimeContainer isMssp={true} />
          </div>
        </div>
        <div className="burn-ration-over-time">
          <div>
            <BurnRatioOverTimeContainer />
          </div>
        </div>
      </div>
    </div>
  );
}
